import Client from './KomodoClient';
import { pagerRows } from './Resource';

// komodo MenuGroupController (api/menu-group) + the product-card endpoints of MaterialController
// used by the menu overview (/menu-group-setup).
const enc = encodeURIComponent;

const list = () => Client.get('/api/menu-group');
const create = (dto) => Client.post('/api/menu-group', dto);
const update = (code, dto) => Client.put(`/api/menu-group/${enc(code)}`, dto);
// Soft delete (StopFlag = true).
const remove = (code) => Client.del(`/api/menu-group/${enc(code)}`);

// Categories mapped to a menu group, filtered by the BranchId company (CategoryMenuGroupDTO[]).
const categoriesOf = (code) =>
	Client.get(`/api/menu-group/mapping/menu-groups/${enc(code)}`).then(
		pagerRows
	);
// Full category × group matrix (virtual inactive rows for unmapped categories).
const mappingsOf = (code) =>
	Client.get(`/api/menu-group/mapping/parent-list/${enc(code)}`).then(
		pagerRows
	);
// Upsert by (menuGroupCode, materialSortCode).
const saveMapping = (dto) => Client.post('/api/menu-group/mapping', dto);
// Batch upsert (portal-only endpoint): category order of a menu group / bulk add in one call.
const saveMappings = (dtos) =>
	Client.post('/api/menu-group/mapping/batch', dtos);

// Product cards of a category subtree (MaterialCardDTO[]), ordered by OrderIndex.
const productCards = (materialSortCode) =>
	Client.get(
		`/api/material/mapping-child-level-cards/${enc(materialSortCode)}`
	).then(pagerRows);
// Persist the drag order: the whole card list, in order.
const saveOrders = (cards) => Client.post('/api/material/orders', cards);
// Appearance (colours / images) of one product card. Blazor posts to a route that does not exist;
// the real one is cards/{materialCode}.
const saveCard = (materialCode, card) =>
	Client.post(`/api/material/cards/${enc(materialCode)}`, card);

export default {
	list,
	create,
	update,
	remove,
	categoriesOf,
	mappingsOf,
	saveMapping,
	saveMappings,
	productCards,
	saveOrders,
	saveCard,
};
